import { useState } from "react";
import { useTranslation } from "react-i18next";
import Page from "app/shared/UI/Layout/Page";
import ImportProspectsPageContent from "app/components/prospect/ImportProspectsPageContent";

const ImportProspectsPage = (props) => {
  const { t } = useTranslation();
  const [varInterval, setVarInterval] = useState(0);

  const backBtnCB = () => {
    if (varInterval > 0) {
      clearInterval(varInterval);
    }
  };

  return (
    <Page
      hasDrawer={false}
      pageTitle={t("pageTitle.importProspects")}
      hasBackButton={true}
      backActionCB={backBtnCB}
      backButtonTooltip={t("common.backButtonToolTip")}
      contentComponent={ImportProspectsPageContent}
      intervalSetter={setVarInterval}
      {...props}
    />
  );
};

export default ImportProspectsPage;
